import { FormikProvider } from 'formik';
import { t } from 'i18next';
import { equals, isEmpty, path } from 'ramda';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { updateCompany } from '../../../modules/company/companyActions';
import useDetectDiffInChanges from '../../../utils/hooks/useDetectDiffInChanges';
import { useForm } from '../../../utils/hooks/useForm';
import { DisplayFlexS } from '../../../utils/stylesHelpers';
import { CheckBox, FieldClarification } from '../common';

import FieldComment from './common/fieldComment';
import SaveBtn from './common/saveBtn';
import SelectsArray from './common/selectsArray';
import { LargeCheckBoxWrapS, LargeCheckBoxOptionS, SaveButtonWrapper } from './companyEditS';

const getInitialValues = (company) => ({
  services: {
    basics: path(['services', 'basics'], company) || false,
    specialisation:
      company.services && company.services.specialisation && company.services.specialisation.length > 0
        ? company.services.specialisation
        : [''],
  },
});

const ServicesSettings = ({ isAdmin, setActiveSettingType }) => {
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company.companyItem);
  const loading = useSelector((state) => state.company.loading);
  const staticCompanyValues = useSelector((state) => state.app.staticCompanyValues);

  const initialValues = getInitialValues(company);

  const handleSubmit = (values) => {
    const notEmpty = (el) => !isEmpty(el);
    const services = {
      basics: values.services.basics,
      specialisation: values.services.specialisation.filter(notEmpty),
    };

    dispatch(updateCompany({ ...company, services }, isAdmin));
  };

  const { formik, values, onChange, onBlur, setFieldValue, onSubmit, dirty } = useForm({
    initialValues,
    onSubmit: handleSubmit,
  });

  const hasChanges = () => !equals(initialValues, values);

  useDetectDiffInChanges(hasChanges, onSubmit, setActiveSettingType);

  return (
    <FormikProvider value={formik}>
      <form onSubmit={onSubmit}>
        <DisplayFlexS flexWrapScreenTablet="wrap" justifyScreenMedium="center">
          <DisplayFlexS justifyScreenMedium="center" direction="column" directionScreenMedium="column" maxWidth="45%">
            <LargeCheckBoxWrapS>
              <label>
                <CheckBox
                  className="checkbox-lg"
                  onChange={() => {
                    setFieldValue('services.basics', !values.services.basics, false);
                  }}
                  checked={values.services.basics}
                />
                <LargeCheckBoxOptionS>{t('companyEdit.labels.services.basics')}</LargeCheckBoxOptionS>
              </label>
            </LargeCheckBoxWrapS>
            <FieldClarification
              transPath="companyEdit.fieldComment.servicesBasicsList"
              isActive={values.services.basics}
              amountCol="2"
              marginRight="20px"
            />
          </DisplayFlexS>
          <FieldComment transPath="companyEdit.fieldComment.servicesBasics" maxWidth="50%" />
        </DisplayFlexS>

        <DisplayFlexS flexWrapScreenTablet="wrap" justifyScreenMedium="center" style={{ marginTop: '30px' }}>
          <SelectsArray
            renderAddNewFieldBtn={(index) =>
              path(['services', 'specialisation'], values).length === index + 1 &&
              path(['services', 'specialisation'], values).length < 2
            }
            transKeyBase="companyServices"
            selectName="services.specialisation"
            options={staticCompanyValues.services.specialisation}
            valuesPath={['services', 'specialisation']}
            values={values}
            onChange={onChange}
            onBlur={onBlur}
          />
          <FieldComment
            transPath="companyEdit.fieldComment.servicesSpecialization"
            maxWidth="50%"
            marginTopScreenTablet="0px"
            marginBottomScreenTablet="20px"
          />
        </DisplayFlexS>

        <SaveButtonWrapper marginTop="30" marginTopMobile="90">
          <SaveBtn loading={loading} disabled={!dirty && !hasChanges(values)} />
        </SaveButtonWrapper>
      </form>
    </FormikProvider>
  );
};

export default ServicesSettings;
